import React from 'react';

import {NoResultPage} from 'src/modules/entitlements';
import {SIZES} from 'src/modules/profile/user/tabs/content/constants';
import {EntityTypeHeader} from 'src/modules/profile/user/tabs/content/layouts/headers/entity-type-header';
import {LayoutNameHeader} from 'src/modules/profile/user/tabs/content/layouts/headers/layout-name-header';
import {LayoutTableRow} from 'src/modules/profile/user/tabs/content/layouts/layout-table-row';
import {COLUMN_WIDTHS} from 'src/modules/profile/user/tabs/content/layouts/util';
import {UserLayout} from 'src/openapi/admin/models/UserLayout';
import {UserLayoutRequest} from 'src/openapi/admin/models/UserLayoutRequest';


import {Group} from '@pb/kit-component-group';
import {PaginationStripe} from '@pb/kit-component-pagination';
import Table, {Body, Cell, Head, Row} from '@pb/kit-component-table';

type Props = {
    data: UserLayout[],
    total: number,
    setPage: (page: number) => void,
    setPageSize: (size: number) => void,
    criteria: UserLayoutRequest,
    isNoCreatedLayouts: boolean,
};

export const LayoutTable = (props: Props) => {
    const {data, total, setPage, setPageSize, criteria, isNoCreatedLayouts} = props;

    return (
        <Group gap="m" direction="v">
            <Table fixed={true} align="middle">
                <Head>
                    <LayoutNameHeader/>
                    <EntityTypeHeader/>
                    <Cell width={COLUMN_WIDTHS.LAYOUT_TYPE}>Layout Type</Cell>
                    <Cell width={COLUMN_WIDTHS.DEFAULT}>Default</Cell>
                </Head>

                <Body>
                    {total > 0 ?
                            data.map((item: UserLayout, i: number) => (
                                <LayoutTableRow
                                    key={item.id}
                                    layout={item}
                                    showZebra={i % 2 === 0}
                                />
                            )) : (
                                <Row>
                                    <Cell colSpan={4} className="text-align_center">
                                        <div style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            padding: '20px 0',
                                        }}>
                                            <NoResultPage
                                                title="No data to show"
                                                description={isNoCreatedLayouts
                                                    ? 'This user has not created any layouts yet.'
                                                    : 'No data found for the selected criteria.'}
                                            />
                                        </div>
                                    </Cell>
                                </Row>
                            )}
                </Body>
            </Table>
            <PaginationStripe
                totalCount={total}
                currentPage={criteria?.page?.currentPage || 1}
                pageSize={criteria?.page?.pageSize || 15}
                onPaginationChange={p => setPage(p.currentPage)}
                showSizeSwitcher={true}
                goToPage={true}
                sizeSwitcherPosition="RIGHT"
                sizes={SIZES}
                onChangePaginationSize={(_p, size) => setPageSize(size)}
            />
        </Group>
    );
};
